import { Component } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { PaymentsService } from 'src/app/core/api/services';
import { BaseIndexModule } from 'src/app/pages/shared/base';
import { BasePaymentsForConfirmComponent } from '../base/base-payments-for-confirm.component';

@Component({
  selector: 'app-payments-for-confirm',
  templateUrl: './payments-for-confirm.component.html',
  imports: [
    BaseIndexModule,
    ReactiveFormsModule,
    BasePaymentsForConfirmComponent,
  ],
})
export class PaymentsForConfirmComponent {
  //#region Properties
  getTableDataApiMethodName: string =
    'paymentsGetPaymentsForConfirmWithPagination';
  pageTitle: string = 'pages.paymentsForConfirm.title';
  //#endregion

  constructor(protected currentService: PaymentsService) {}
}
